module.exports = __webpack_public_path__ + "img/caution_02.0df4462a.png";